import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FileModel, PdfVersionsModel, VersionsModel} from '../../../models/file.model';
import {HelpersService} from '../../../services/helpers.service';
import {catchError, EMPTY, filter, Observable, ReplaySubject, Subscription, switchMap} from 'rxjs';
import {ModalService} from '../../../services/modal/modal.service';
import {DocumentsApiService} from '../../../services/api/documents-api.service';
import {AlertService} from '../../../services/notify/alert.service';
import {FileQueueService} from '../../../services/file-queue.service';
import {saveAs} from 'file-saver';
import {Router} from '@angular/router';
import {MemberModel} from '../../../models/user.model';
import {TranslateService} from '@ngx-translate/core';
import { AppContentDialogComponentMT } from '../../material/content-dialog/app-content-dialog.component';
import { DialogsMTService } from '../../../services/modal/dialogs-mt.service';
import { IconBaseService } from '../../../services/icon-base.service';
import { AppDocVersionListComponent } from '../doc-version-list/doc-version-list.component';

export class FileToolbarController {
    public $onFullscreen: ReplaySubject<boolean> = new ReplaySubject<boolean>();

    public $onSing: ReplaySubject<boolean> = new ReplaySubject<boolean>();

    public $onSelectVersion: ReplaySubject<VersionsModel | PdfVersionsModel> = new ReplaySubject<VersionsModel | PdfVersionsModel>();

    public $onDownload: ReplaySubject<boolean> = new ReplaySubject<boolean>();
  }

@Component({
    selector: 'app-file-toolbar',
    templateUrl: './file-toolbar.component.html',
    styleUrls: ['./file-toolbar.component.scss'],
})
export class FileToolbarComponent implements OnInit {
    @Input() public pdfVersion!: PdfVersionsModel|null;
    @Input() public right!: {
        is_read_all: boolean,
        is_read_approved_doc: boolean,
        is_edit_signer: boolean,
        is_edit_approver: boolean,
        is_edit_settings: boolean,
        is_edit_property: boolean,
        is_create_folder: boolean,
        is_upload_file: boolean,
        is_locked_collection: boolean,
        is_delete: boolean,
        is_read_my_doc: boolean,
        use_custom_rights: boolean,
    };
    @Input() public fileModel!: FileModel;
    @Input() public fullscreen = false;
    @Input() public currentVersion!: PdfVersionsModel | VersionsModel;
    @Input() public controller!: FileToolbarController;
    @Input() public isOpenModal!: boolean;
    @Input() public lockSignButton!: boolean;
    @Input() public currentMemberSigner!: boolean;
    @Input() public isImSign = false;
    @Input() public currentMember!: MemberModel;

    @Output() public newVersionEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() public updateEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() public deleteEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() public approveEmit: EventEmitter<any> = new EventEmitter<any>();

    public isDownloadLoaderDocx = false;
    public isDownloadLoaderPdf = false;
    pin!: string;
    isLockButton = false;
    isDeleteLoader = false;
    isUpdateFile = false;
    description: string = '';
    
    private subs: Subscription = new Subscription();
    public versionHistoryDialogRef:MatDialogRef<AppDocVersionListComponent>|null=null
    private contentDialogRef!: MatDialogRef<any>;

    constructor(
        protected modalService: ModalService,
        protected documentApi: DocumentsApiService,
        public alert: AlertService,
        private fileQueueService: FileQueueService,
        public helper: HelpersService,
        public router: Router,
        public translate: TranslateService,
        private dialog: MatDialog,
        private changeDetectionRef: ChangeDetectorRef,
        private iconBaseService: IconBaseService,
        private dialogsMTService: DialogsMTService,
    ) {
    }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
        this.pdfVersion = null;
        if (this.fileModel && this.fileModel.pdf_version) {
            this.pdfVersion = Object.assign(new PdfVersionsModel(), this.fileModel.pdf_version);
        }
        this.setSubscriptions()
    }
    setSubscriptions() {
      this.subs.add(this.controller.$onSelectVersion.asObservable().subscribe(()=>this.versionHistoryDialogRef?.close()))
    }
    toggleVersionHistory() {
        this.versionHistoryDialogRef = this.dialog.open(AppDocVersionListComponent,{  
          panelClass:'file-toolbar-dialog', 
          maxHeight:'95vh', 
          position:{top:'100px',right:'100px'}
        })
        this.versionHistoryDialogRef.componentInstance.versions = this.fileModel?.versions;
        this.versionHistoryDialogRef.componentInstance.fileToolbarController = this.controller;
    }
    isPdfView(): boolean {
        return this.currentVersion instanceof PdfVersionsModel;
    }

    onFullscreenBtn(on: boolean): void {
        this.fullscreen = on;
        this.controller.$onFullscreen.next(on);
    }

    openDialog(content: TemplateRef<any>,minWidth?:number,minHeight?:number) {
      this.contentDialogRef = this.dialog.open(AppContentDialogComponentMT,{
        panelClass:'file-toolbar-dialog',minHeight:minHeight,minWidth:minWidth, maxHeight:'95vh'
    })
      this.contentDialogRef.componentInstance.templateRef = content
    }

    onNewVersion(file:any, description:any): void {
        if (!file.files[0]) {
            this.alert.setAlert(this.translate.instant('ALERTS.FILE_NOT_SELECTED'), 'blue');
            return;
        }
        this.isLockButton = true;
        const data = {
            file: file.files[0],
            desc: description.value,
        };
        this.newVersionEmit.emit(data);
        this.isUpdateFile = false;
        this.isLockButton = false;
        this.contentDialogRef? this.contentDialogRef.close() : null;
    }

    onCheckErrorSign(): void {
        if (this.currentVersion.key !== this.fileModel.latest_version.key && !this.fileModel.pdf_version) {
            this.alert.setAlert(this.translate.instant('ALERTS.SIGN_FILE_LAST_VERSION'), 'blue');
            return;
        }

        if (this.fileModel.latest_version.status === 'job') {
            this.alert.setAlert(this.translate.instant('ALERTS.SIGN_FILE_WAIT'), 'blue');
            return;
        }

        if (this.fileModel.latest_version.status === 'error') {
            this.alert.setAlert(this.translate.instant('ALERTS.SIGN_FILE_ERROR'), 'blue');
            return;
        }

			const isSign = !this.isImSign;
			this.isLockButton = true;
			this.dialogsMTService.openPinDialog(isSign,this.translate.instant('MODALS.HEADERS.SIGN'))
				.pipe(
					filter(pin=>pin.pin !==null),
					switchMap(pin=>this.onSign(pin.pin.toString())),
					catchError(() => {
						return EMPTY;
					})
				).subscribe(res=>{
					this.alert.setAlert(res.message, 'nd_color');
					this.fileQueueService.findNewTask();
					this.controller.$onSing.next(true);
					this.isLockButton = false;
					this.changeDetectionRef.detectChanges()
				})
    }

    onSign(pin:string): Observable<any> {
        return this.documentApi.signFile(pin, this.fileModel.key)
				.pipe(
					catchError(error=>{
						this.alert.setAlert(error.message, 'blue');
						this.controller.$onSing.next(false);
						this.isLockButton = false;
						this.changeDetectionRef.detectChanges()
						return EMPTY
					})
				)
    }

    downloadFile(isOrigin: boolean, format: 'pdf' | 'docx' | 'xlsx' = 'pdf'): void {
        if (this.isDownloadLoaderPdf || this.isDownloadLoaderDocx) {
            return;
        }

        if (format !== 'pdf') {
            this.isDownloadLoaderDocx = true;
        } else {
            this.isDownloadLoaderPdf = true;
        }

        let req: Observable<any>;
        let currentName: string | undefined = this.currentVersion.name;

        if (this.currentVersion instanceof PdfVersionsModel && !isOrigin) {
            req = this.documentApi.getIntermediateVersion(this.currentVersion.key);
        } else {
            let versionKey: string;
            if (this.currentVersion instanceof PdfVersionsModel) {
                versionKey = this.fileModel.latest_version.key;
            } else {
                versionKey = this.currentVersion.key;
            }
            if (!isOrigin) {
                currentName = currentName?.split('.').slice(0, -1).join('') + '.' + format;
            }

            req = this.documentApi.getFileBodyVersion(versionKey, format, isOrigin);
        }

        req.subscribe({
            next: data => {
                const file = new Blob([data as BlobPart]);
                saveAs(file, currentName);
                if (format !== 'pdf') {
                    this.isDownloadLoaderDocx = false;
                } else {
                    this.isDownloadLoaderPdf = false;
                }
            }, error: () => {
                this.alert.setAlert(this.translate.instant('ALERTS.ERROR'), 'blue');
                if (format !== 'pdf') {
                    this.isDownloadLoaderDocx = false;
                } else {
                    this.isDownloadLoaderPdf = false;
                }
            }
        });
    }

    deleteFile(): void {
      if (this.isDeleteLoader) {
          return;
      }
      this.dialogsMTService.confirmDialog({actionHeader: 'CONFIRM.HEADERS.DELETE',actionBody: 'CONFIRM.TEXT.DELETE_FILE' })
      .pipe(
        filter(res => res.isConfirmed),
        switchMap(()=>this.documentApi.deleteFile(this.fileModel.key).pipe(
          catchError(e => {
              this.alert.setAlert(e.message, 'blue');
              return EMPTY
            }))
          ),
        catchError(() => {
						return EMPTY
        }))
      .subscribe(() => {
        this.deleteEmit.emit();
        if (!this.isOpenModal) {
          this.router.navigate(['/account', 'doc', 'collection', this.fileModel.collection_id]);
        }
        this.alert.setAlert(this.translate.instant('ALERTS.DELETE_FILE'), 'green');
        this.isDeleteLoader = false;
      });
    }
    editDocumentData(newName: string): void {
        const data = {
            name: newName,
            file_description: this.description,
        };

        this.documentApi.editDocumentData(this.fileModel.key, data).subscribe({
            next: () => {
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                this.updateEvent.emit();
                this.contentDialogRef.close();
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            }
        });
    }
}
